/* eslint-disable max-len */
/* eslint-disable react/prop-types */
import { CheckCircleOutlined, RedoOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  DatePicker,
  Form,
  Input,
  Modal,
  Row,
  Spin,
  TreeSelect,
} from 'antd';
import { getCuentasContables, getEstadosGlobales, getPeriodicidadesDePagos } from 'api/catalogos/index';
import { getClasesDeContrataciones } from 'api/nominas/catalogos/clasesDeContrataciones';
import { getSujetosDeNomina } from 'api/catalogos/admnistracionDePlazas';
import {
  deleteTipoDeNominaEmpleado,
  getTipoDeNominaEmpleado,
  getTiposDeNominasEmpleados,
  patchTipoDeNominaEmpleado,
  postTipoDeNominaEmpleado,
} from 'api/nominas/catalogos/tiposNominasEmpleados';
import { checkToken } from 'api/utils';
import FormSubmitControls from 'components/FormSubmitControls';
import ModalConfirmation from 'components/ModalConfirmation';
import ModalDelete from 'components/ModalDelete';
import Select from 'components/Select';
import Table from 'components/Table';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import {
  ESTATUS_ACTIVO,
  ESTATUS_AUTORIZADO,
  ESTATUS_INACTIVO,
} from 'utils/constants';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import makeTreeCuentasContable from 'utils/makeTreeFromCuentasContables';
import {
  SLUG_PATTERN,
} from 'utils/patterns';

export const tipoDeNominaEmpleadoPermission = {
  permissionModel: 'tipodenominaempleado',
  catalogsModels: [],
  tabsModels: [],
};

const TipoDeNominaEmpleado = ({ permission }) => {
  const [form] = Form.useForm();
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setVisible] = useState(false);
  const [visibleAlert, setVisibleAlert] = useState(false);
  const [data, setData] = useState([]);
  const [estados, setEstados] = useState([]);
  const [periodicidades, setPeriodicidades] = useState([]);
  const [cuentasContables, setCuentasContables] = useState([]);
  const [confirmationVisible, setConfirmationVisible] = useState(false);
  const [confirmationVisibleEstatus, setConfirmationVisibleEstatus] = useState(false);
  const [estatusInactivo, setEstatusInactivo] = useState(false);
  const [estatusAutorizado, setEstatusAutorizado] = useState(false);
  const [estadosFiltered, setEstadosFiltered] = useState([]);
  const [disableAuth, setDisableAuth] = useState(false);
  const [disableReactivar, setDisableReactivar] = useState(true);
  const [confirmationVisibleReactivar, setConfirmationVisibleReactivar] = useState(false);
  const [clasesDeContrataciones, setClasesDeContrataciones] = useState([]);
  const [sujetosDeNomina, setSujetosDeNomina] = useState([]);

  const formInstances = [
    form,
  ];

  // const calcularProfundidadMaxima = (arreglo) => {
  //   let maxProfundidad = 0;
  //   const calcularProfundidadRecursiva = (nodo, profundidad) => {
  //     maxProfundidad = Math.max(maxProfundidad, profundidad);
  //     if (!nodo.children || nodo.children.length === 0) {
  //       return;
  //     }
  //     nodo.children.forEach((hijo) => {
  //       calcularProfundidadRecursiva(hijo, profundidad + 1);
  //     });
  //   };
  //   arreglo.forEach((nodo) => {
  //     calcularProfundidadRecursiva(nodo, 1);
  //   });
  //   return maxProfundidad;
  // };

  // const agregarDisabledEnNivelMasProfundo = (arreglo) => {
  //   const profundidadMaxima = calcularProfundidadMaxima(arreglo);
  //   const agregarDisabledRecursivo = (nodo, profundidadActual) => {
  //     if (!nodo.children || nodo.children.length === 0) {
  //       if (profundidadActual === profundidadMaxima) {
  //         if (nodo?.tipo === 7) {
  //           // eslint-disable-next-line no-param-reassign
  //           nodo.disabled = false;
  //         } else {
  //           // eslint-disable-next-line no-param-reassign
  //           nodo.disabled = true;
  //         }
  //         return;
  //       }
  //       // eslint-disable-next-line no-param-reassign
  //       nodo.disabled = true;
  //       return;
  //     }
  //     if (profundidadActual === profundidadMaxima) {
  //       // eslint-disable-next-line no-param-reassign
  //       nodo.disabled = false;
  //     } else {
  //       // eslint-disable-next-line no-param-reassign
  //       nodo.disabled = true;
  //     }
  //     nodo.children.forEach((hijo) => {
  //       agregarDisabledRecursivo(hijo, profundidadActual + 1);
  //     });
  //   };
  //   arreglo.forEach((nodo) => {
  //     agregarDisabledRecursivo(nodo, 1);
  //   });
  // };

  const normalizeCuentasContables = (_data) => {
    if (_data) {
      const output = _data.map((item) => {
        const clone = { ...item };
        const children = normalizeCuentasContables(clone.children);
        // Solo es seleccionable si es tipo === 7 (afectable) y es hoja (sin hijos)
        const isAfectable = clone.tipo === 7;
        const isLeaf = !children.length;
        const selectable = isLeaf && isAfectable;
        if (!children.length) {
          delete clone.children;
          return ({
            ...clone,
            title: `${clone.clave_visible || clone.clave} - ${clone.nombre}`,
            value: clone.id,
            key: clone.id,
            disabled: !selectable,
          });
        }
        return ({
          ...clone,
          title: `${clone.clave_visible || clone.clave} - ${clone.nombre}`,
          value: clone.id,
          key: clone.id,
          children,
          disabled: !selectable,
        });
      });
      return output;
    }
    return [];
  };

  const fetchData = async () => {
    setLoading(true);
    const _data = await getTiposDeNominasEmpleados();
    setData(formatReceived(_data));
    setLoading(false);
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _estados,
        _periodicidades,
        _cuentasContables,
        _clasesDeContrataciones,
        _data,
        _sujetosDeNomina,
      ] = await Promise.all([
        getEstadosGlobales(),
        getPeriodicidadesDePagos({ estados_globales: ESTATUS_AUTORIZADO }),
        getCuentasContables(),
        getClasesDeContrataciones(),
        getTiposDeNominasEmpleados(),
        getSujetosDeNomina(),
      ]);
      if (mounted) {
        setEstados(_estados);
        setPeriodicidades(_periodicidades);
        const normalizedCuentas = normalizeCuentasContables(makeTreeCuentasContable(_cuentasContables));
        setCuentasContables(normalizedCuentas);
        setClasesDeContrataciones(_clasesDeContrataciones);
        setData(formatReceived(_data));
        if (Array.isArray(_sujetosDeNomina) && _sujetosDeNomina.length) {
          setSujetosDeNomina(_sujetosDeNomina);
        }
        setLoading(false);
      }
    };
    fetchAll();
    return () => { mounted = false; };
    // eslint-disable-next-line
  }, []);

  const onCancel = () => {
    setEstatusInactivo(false);
    setEstatusAutorizado(false);
    setDisableReactivar(true);
    setSelectedRowKeys([]);
    setVisible(false);
    form.resetFields();
  };

  const onClickEdit = async (responseData = null) => {
    setLoading(true);
    const [key] = selectedRowKeys;
    const match = responseData || data.find((item) => item.id === key);
    const _plaza = await getTipoDeNominaEmpleado(match.id);
    if (_plaza?.estados_globales === ESTATUS_ACTIVO
      || _plaza?.estados_globales === ESTATUS_INACTIVO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_INACTIVO
        || estado?.id === ESTATUS_ACTIVO));
    }
    if (_plaza?.estados_globales === ESTATUS_AUTORIZADO) {
      setEstadosFiltered(estados.filter((estado) => estado?.id === ESTATUS_AUTORIZADO));
      setEstatusAutorizado(true);
    }
    if (_plaza?.estados_globales === ESTATUS_INACTIVO) {
      setEstatusInactivo(true);
    }
    setTimeout(() => {
      const formValues = {
        // Formatea la información recibida (según lógica definida en formatReceived)
        ...formatReceived(_plaza),
        vigencia_final: _plaza.vigencia_final
          ? moment(_plaza.vigencia_final)
          : null,

      };
      if (_plaza) {
        form.resetFields();
        setTimeout(() => {
          form.setFieldsValue(formatReceived(formValues));
          setVisible(true);
        });
      }
    });
    setLoading(false);
  };

  const onFinish = async (_values, _continue = false) => {
    try {
      setLoading(true);
      await form.validateFields();
      const values = {
        ...form.getFieldsValue(),
      };
      const [key] = selectedRowKeys;
      // eslint-disable-next-line max-len

      if (values.vigencia_final?.format) {
        values.vigencia_final = values.vigencia_final.format('YYYY-MM-DD');
      }

      const saved = await (key ? patchTipoDeNominaEmpleado(key, values) : postTipoDeNominaEmpleado(values));
      if (saved) {
        if (_continue) {
          await fetchData();
          setSelectedRowKeys([saved.id]);
          onClickEdit(saved);
        } else {
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(
        err,
        setLoading,
        formInstances,
      );
    }
  };

  const deleteItem = async () => {
    try {
      setLoading(true);
      if (selectedRowKeys.length) {
        const [key] = selectedRowKeys;
        const deleted = await deleteTipoDeNominaEmpleado(key);
        if (deleted) {
          setVisibleAlert(false);
          onCancel();
          await fetchData();
        }
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    const isAutorizado = record?.estados_globales === ESTATUS_AUTORIZADO;
    const isInactivo = record?.estados_globales === ESTATUS_INACTIVO;
    const isActivo = record?.estados_globales === ESTATUS_ACTIVO;
    setDisableAuth(isAutorizado || isInactivo);
    setDisableReactivar(isActivo);
    const dataForForm = {
      ...record,
      vigencia_final: record.vigencia_final
        ? moment(record.vigencia_final)
        : null,
    };
    form.setFieldsValue(dataForForm);
  };

  const rowSelection = {
    selectedRowKeys,
    type: 'radio',
  };

  const onClickAdd = () => {
    setEstadosFiltered(estados);
    onCancel();
    setVisible(true);
  };

  const onClickDelete = () => {
    setVisibleAlert(true);
  };

  const handleOnFinishConfirmation = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede autorizar una nómina ya autorizada');
        return;
      }
      const vals = {
        ...form.getFieldValue(),
        estados_globales: ESTATUS_AUTORIZADO,
      };
      const res = await patchTipoDeNominaEmpleado(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setConfirmationVisible(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const handleOnFinishConfirmationEstatus = async () => {
    setConfirmationVisibleEstatus(false);
  };

  const handleOnFinishReactivarConfirmation = async () => {
    try {
      setLoading(true);
      const [key] = selectedRowKeys;
      if (!key) {
        setLoading(false);
        onCancel();
        onSuccess({}, 'No se puede reactivar un tipo de nómina empleado ya activo');
        return;
      }
      const vals = {
        ...form.getFieldValue(),
        estados_globales: ESTATUS_ACTIVO,
      };
      const res = await patchTipoDeNominaEmpleado(key, vals);
      if (res) {
        onSuccess(res);
        await fetchData();
        setConfirmationVisibleReactivar(false);
      }
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  const flattenTree = (nodes) => {
    let flat = [];
    nodes.forEach((node) => {
      if (node) {
        flat.push(node);
        if (node.children && node.children.length > 0) {
          flat = flat.concat(flattenTree(node.children));
        }
      }
    });
    return flat;
  };

  // Y luego la usas así:
  const cuentasContablesFlattened = flattenTree(cuentasContables);

  const columns = [
    {
      titleText: 'Clave',
      dataIndex: 'clave',
      key: 'clave',
      width: 200,
    },
    {
      titleText: 'Descripción',
      dataIndex: 'descripcion',
      key: 'descripcion',
      width: 400,
    },
    {
      titleText: 'Periodicidad de Pago',
      dataIndex: 'periodicidad_de_pago',
      key: 'periodicidad_de_pago',
      width: 400,
      render: (val) => periodicidades.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'Aplica Subsidio',
      dataIndex: 'aplica_subsidio',
      key: 'aplica_subsidio',
      width: 200,
      render: (val) => (val ? 'Si' : 'No'),
    },
    {
      titleText: 'Cuenta Contable',
      dataIndex: 'cuenta_contable',
      key: 'cuenta_contable',
      width: 450,
      render: (val) => {
        const _cuentaContable = cuentasContablesFlattened.find((e) => e.id === val);
        if (!_cuentaContable) {
          return '';
        }
        return `${_cuentaContable?.clave_visible || _cuentaContable?.clave} - ${_cuentaContable?.nombre}`;
      },
    },
    {
      titleText: 'Clase de Contratación',
      dataIndex: 'clase_contratacion',
      key: 'clase_contratacion',
      width: 150,
      render: (val) => clasesDeContrataciones.find((e) => e.id === val)?.descripcion,
    },
    {
      titleText: 'Sujeto de Nómina',
      dataIndex: 'content_type_model',
      key: 'content_type_model',
      width: 150,
      render: (val) => sujetosDeNomina.find((s) => s.slug === val)?.etiqueta,
    },
    {
      titleText: 'Vigencia Final',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      width: 150,
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
    contratacion: [requiredRule],
    estatus: [requiredRule],
    clave: [
      requiredRule,
      {
        pattern: SLUG_PATTERN,
        message: 'Ingrese una clave válida',
      },
    ],
  };

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data}
          rowSelection={rowSelection}
          handleOnRowClick={handleOnRowClick}
          controls={{
            onClickAdd,
            onClickEdit: () => onClickEdit(),
            onClickDelete,
          }}
          disableDelete={
            data?.find((e) => e?.id === selectedRowKeys[0])?.estados_globales === ESTATUS_AUTORIZADO
          }
          customActions={[
            {
              onClick: () => setConfirmationVisible(true),
              permission: { model: 'tipodenominaempleado', action: 'autorizar' },
              text: 'Autorizar',
              icon: <CheckCircleOutlined />,
              disabledBySelection: false,
              className: 'success',
              disabled: !selectedRowKeys?.length || disableAuth,
            },
            {
              onClick: () => setConfirmationVisibleReactivar(true),
              permission: { model: 'tipodenominaempleado', action: 'reactivar' },
              text: 'Reactivar',
              icon: <RedoOutlined />,
              disabledBySelection: false,
              className: 'success',
              disabled: !selectedRowKeys?.length || disableReactivar,
            },
          ]}
          permission={permission}
          allowExportPDF={false}
        />
        <Modal
          open={open}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          footer={null}
          title={(
            <FormSubmitControls
              label={`${selectedRowKeys.length ? 'Editar' : 'Agregar'} Tipo de Nómina Empleado`}
              onFinish={onFinish}
              onCancel={onCancel}
              loading={loading}
              allowSave={!selectedRowKeys?.length || !disableAuth}
            />
          )}
          onCancel={onCancel}
          forceRender
          width="45%"
        >
          <Form
            layout="vertical"
            form={form}
            onFinish={onFinish}
            scrollToFirstError
            name="general"
            initialValues={{
              aplica_subsidio: false,
            }}
          >
            <Row gutter={10}>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="clave"
                  rules={rules.clave}
                  label="Clave"
                  hasFeedback
                >
                  <Input
                    allowClear
                    disabled={estatusAutorizado || estatusInactivo}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="descripcion"
                  rules={rules.required}
                  label="Descripción"
                  hasFeedback
                >
                  <Input
                    allowClear
                    disabled={estatusAutorizado || estatusInactivo}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="periodicidad_de_pago"
                  label="Periodicidad Pago"
                  rules={rules.required}
                  hasFeedback
                >
                  <Select
                    dataSource={periodicidades}
                    disabled={estatusAutorizado || estatusInactivo}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="aplica_subsidio"
                  label="Aplica Subsidio al Empleo"
                  rules={rules.required}
                >
                  <Select
                    trueFalse
                    disabled={estatusAutorizado || estatusInactivo}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="cuenta_contable"
                  rules={rules.required}
                  label="Cuenta Contable de Sueldos por Pagar"
                  hasFeedback
                >

                  <TreeSelect
                    keyProp="clave"
                    labelProp="nombre"
                    showSearch
                    treeNodeFilterProp="title"
                    treeData={cuentasContables}
                    disabled={estatusAutorizado || estatusInactivo}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="clases_de_contratacion"
                  rules={rules.required}
                  label="Clase de Contratación"
                  hasFeedback
                >
                  <Select
                    mode="multiple"
                    dataSource={clasesDeContrataciones}
                    keyProp="id"
                    labelProp="descripcion"
                    allowClear
                    disabled={estatusAutorizado || estatusInactivo}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="content_type"
                  label="Sujeto de Nómina"
                  hasFeedback
                >
                  <Select
                    dataSource={sujetosDeNomina}
                    valueProp="content_type"
                    labelProp="etiqueta"
                    allowClear
                    disabled={estatusAutorizado || estatusInactivo}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="vigencia_final"
                  label="Vigencia Final"
                  hasFeedback
                >
                  <DatePicker
                    placeholder=""
                    allowClear
                    format="YYYY-MM-DD"
                    disabled={!selectedRowKeys.length || estatusInactivo}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} sm={24} md={12}>
                <Form.Item
                  name="estados_globales"
                  label="Estatus"
                  rules={rules.estatus}
                  hasFeedback
                  initialValue={1}
                >
                  <Select
                    labelProp="descripcion"
                    keyProp="id"
                    dataSource={estadosFiltered}
                    disabled={!selectedRowKeys.length || estatusAutorizado || estatusInactivo}
                    onChange={(val) => {
                      if (val === ESTATUS_INACTIVO) {
                        setConfirmationVisibleEstatus(true);
                      }
                    }}
                  />
                </Form.Item>
              </Col>
              <Form.Item hidden>
                <Button htmlType="submit" />
              </Form.Item>
            </Row>
          </Form>
        </Modal>
        <ModalDelete
          onDelete={deleteItem}
          onCancel={() => setVisibleAlert(false)}
          open={visibleAlert}
          content={`Tipo de Nómina Empleado ${form.getFieldValue('descripcion')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmation}
          ConfirmAutorize
          onCancel={() => {
            setConfirmationVisible(false);
          }}
          open={confirmationVisible}
          contentTitle={`Autorizar el Tipo de Nómina Empelado ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishConfirmationEstatus}
          ConfirmInactive
          onCancel={() => {
            setConfirmationVisibleEstatus(false);
            form.setFieldValue('estados_globales', 1);
          }}
          open={confirmationVisibleEstatus}
          contentTitle={`Inactivar el Tipo de Nómina Empleado ${form.getFieldValue('clave')}`}
          loading={loading}
        />
        <ModalConfirmation
          onFinish={handleOnFinishReactivarConfirmation}
          onFinishText="Reactivar"
          onFinishIcon={<RedoOutlined />}
          onCancel={() => {
            setConfirmationVisibleReactivar(false);
          }}
          open={confirmationVisibleReactivar}
          contentTitle={`Reactivar el Tipo de Nómina Empleado ${form.getFieldValue('clave')}`}
          loading={loading}
        />
      </Spin>
    </Row>
  );
};

export default TipoDeNominaEmpleado;
